import Dialog from "@/components/general/modal/dialog/Dialog"
import { useEffect, useRef, useCallback } from "react"
import styles from './gallery-modal.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

export default function GalleryModal({ isOpen, onClose, children }) {
  const modalRef = useRef()
  const handleClickOutside = useCallback((e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      onClose()
    }
  }, [onClose])
  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isOpen, handleClickOutside])
  return (
    <Dialog value={isOpen} stylingClass={styles.wrapper}>
      <div ref={modalRef} className={styles.galleryBox}>
        <FontAwesomeIcon icon={faTimes} className={styles.close} onClick={onClose} />
        {children}
      </div>
    </Dialog>
  )
}